/**
 * How a resolved dispute can be settled by hand (B47). Mirrors the API's
 * `settlementMethodsFor`: money paid only when something is owed, a recovery
 * only on an overpayment, "nothing due" only when nothing is.
 */
export type ManualSettlementMethod =
  "CASH" | "BANK_TRANSFER" | "CHEQUE" | "RECOVERED" | "NO_PAYMENT_DUE";

export const settlementMethodsFor = (
  adjustment: number,
): ManualSettlementMethod[] =>
  adjustment > 0.004
    ? ["CASH", "BANK_TRANSFER", "CHEQUE"]
    : adjustment < -0.004
      ? ["RECOVERED"]
      : ["NO_PAYMENT_DUE"];

/** Methods that fit every selected dispute; empty when they disagree. */
export const commonSettlementMethods = (
  adjustments: number[],
): ManualSettlementMethod[] => {
  if (!adjustments.length) return [];
  return adjustments
    .map(settlementMethodsFor)
    .reduce((acc, m) => acc.filter((x) => m.includes(x)));
};

export const settlementNeedsReference = (m: string) =>
  m === "BANK_TRANSFER" || m === "CHEQUE" || m === "RECOVERED";
